(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bsw-bricks-planner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bsw-bricks-planner')) {
  customElements.define('bsw-bricks-planner', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      this.widthInput = this.querySelector('[data-width]');
      this.heightInput = this.querySelector('[data-height]');
      this.allowanceInput = this.querySelector('[data-allowance]');
      this.inputs = [this.widthInput, this.heightInput, this.allowanceInput];
      this.inquiry = this.querySelector('[data-inquiry]');
      this.fallbackUrl = this.inquiry.getAttribute('href');
      
      this.addEventListener('input', () => this.update(), {signal: this.controller.signal});
      this.inquiry.addEventListener('click', (event) => {
        if (this.inquiry.getAttribute('aria-disabled') === 'true') event.preventDefault();
      }, {signal: this.controller.signal});
      
      this.update();
    }
    disconnectedCallback() { 
      if (this.controller) this.controller.abort(); 
    }
    update() {
      const width = parseFloat(this.widthInput.value) || 0;
      const height = parseFloat(this.heightInput.value) || 0;
      const allowance = parseFloat(this.allowanceInput.value) || 0;

      const count = this.querySelector('[data-count]');
      const summary = this.querySelector('[data-summary]');

      const valid = width > 0 && height > 0 && width <= 1000 && height <= 1000 && allowance >= 0 && allowance <= 100;
      this.inputs.forEach(input => input.setAttribute('aria-invalid', String(!input.validity.valid)));

      if (!valid) {
        if (count) count.textContent = '—';
        if (summary) summary.textContent = 'Please enter valid dimensions.';
        this.inquiry.setAttribute('aria-disabled', 'true');
        this.inquiry.removeAttribute('href');
        return;
      }

      const area = Number((width * height).toFixed(1));
      const pieces = Math.ceil(Number((area * 4.5 * (1 + allowance / 100)).toFixed(8)));

      if (count) count.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en').format(pieces);
      if (summary) {
        summary.textContent = `${area} sq ft wall area · ${allowance}% allowance for cuts and spares.`;
      }

      this.inquiry.removeAttribute('aria-disabled');
      const phone = this.dataset.whatsapp ? this.dataset.whatsapp.replace(/[^0-9]/g, '') : '';
      const requestText = `Hello, I need an estimate for ${pieces} salt bricks (${width}ft x ${height}ft with ${allowance}% allowance).`;
      this.inquiry.href = phone ? `https://wa.me/${phone}?text=${encodeURIComponent(requestText)}` : this.fallbackUrl;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsw-home-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bsw-home-navigation')) {
  customElements.define('bsw-home-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      
      const toggle = this.querySelector('.menu-toggle');
      const menu = this.querySelector('#mobile-menu');
      const searchToggle = this.querySelector('[data-search-toggle]');
      const search = this.querySelector('#bsw-home-search');
      const iconHamburger = toggle ? toggle.querySelector('.icon-hamburger') : null;
      const iconClose = toggle ? toggle.querySelector('.icon-close') : null;

      // Sync Dynamic Body Offset accurately without CLS
      const updateOffset = () => {
        const height = this.offsetHeight;
        if (height > 0) {
          document.documentElement.style.setProperty('--bsw-header-height', height + 'px');
        }
      };
      window.requestAnimationFrame(updateOffset);
      window.addEventListener('resize', updateOffset, { signal, passive: true });

      // Sticky Scroll Behavior with requestAnimationFrame
      let lastY = window.pageYOffset || document.documentElement.scrollTop;
      const threshold = 100;
      let ticking = false;

      window.addEventListener('scroll', () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            const currentY = window.pageYOffset || document.documentElement.scrollTop;

            if (menu && !menu.hidden) {
              this.classList.remove('header-hidden');
              lastY = currentY;
              ticking = false;
              return;
            }

            if (currentY <= 10) {
              this.classList.remove('header-hidden', 'header-sticky');
            } else if (currentY > lastY && currentY > threshold) {
              this.classList.add('header-hidden');
              this.classList.remove('header-sticky');
            } else if (currentY < lastY) {
              this.classList.remove('header-hidden');
              this.classList.add('header-sticky');
            }

            lastY = currentY <= 0 ? 0 : currentY;
            ticking = false;
          });
          ticking = true;
        }
      }, { signal, passive: true });

      // Announcement Slider Auto Rotation
      const slides = this.querySelectorAll('.announcement-slide');
      const intervalSpeed = parseInt(this.dataset.autoplay, 10) * 1000;

      if (slides.length > 1 && intervalSpeed > 0) {
        let currentIndex = 0;
        const slideInterval = setInterval(() => {
          slides[currentIndex].classList.remove('is-active');
          currentIndex = (currentIndex + 1) % slides.length;
          slides[currentIndex].classList.add('is-active');
        }, intervalSpeed);

        signal.addEventListener('abort', () => clearInterval(slideInterval));
      }

      // Mobile Menu Actions
      const closeMenu = () => { 
        if (!menu || !toggle) return;
        menu.hidden = true; 
        menu.classList.remove('open'); 
        toggle.setAttribute('aria-expanded', 'false'); 
        toggle.setAttribute('aria-label', this.dataset.openLabel || 'Open Menu'); 
        if (iconHamburger) iconHamburger.style.display = 'block';
        if (iconClose) iconClose.style.display = 'none';
      };

      if (toggle && menu) {
        toggle.addEventListener('click', () => { 
          const open = toggle.getAttribute('aria-expanded') !== 'true'; 
          menu.hidden = !open; 
          menu.classList.toggle('open', open); 
          toggle.setAttribute('aria-expanded', String(open)); 
          toggle.setAttribute('aria-label', open ? (this.dataset.closeLabel || 'Close Menu') : (this.dataset.openLabel || 'Open Menu')); 
          if (iconHamburger) iconHamburger.style.display = open ? 'none' : 'block';
          if (iconClose) iconClose.style.display = open ? 'block' : 'none';
          
          if (open) {
            this.classList.remove('header-hidden');
            this.classList.add('header-sticky');
          }
        }, { signal });

        menu.addEventListener('click', event => { 
          if (event.target.closest('a')) closeMenu(); 
        }, { signal });
      }

      // Mobile Accordion Submenu Toggle
      const submenuToggles = this.querySelectorAll('.mobile-dropdown-toggle');
      submenuToggles.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const isExpanded = btn.getAttribute('aria-expanded') === 'true';
          const item = btn.closest('.mobile-nav-item');
          const submenu = item ? item.querySelector('.mobile-submenu') : null;
          
          if (submenu) {
            submenu.hidden = isExpanded;
            btn.setAttribute('aria-expanded', String(!isExpanded));
            btn.classList.toggle('is-open', !isExpanded);
          }
        }, { signal });
      });

      // Search Drawer Open/Close
      if (searchToggle && search) {
        searchToggle.addEventListener('click', () => { 
          search.hidden = !search.hidden; 
          searchToggle.setAttribute('aria-expanded', String(!search.hidden)); 
          if (!search.hidden) {
            const input = search.querySelector('input[type="search"]');
            if (input) input.focus();
          }
        }, { signal });
      }

      // ESC Key Listener
      this.addEventListener('keydown', event => { 
        if (event.key !== 'Escape') return; 
        if (search && !search.hidden) { 
          search.hidden = true; 
          if (searchToggle) {
            searchToggle.setAttribute('aria-expanded', 'false'); 
            searchToggle.focus(); 
          }
        } else if (menu && !menu.hidden) { 
          closeMenu(); 
          if (toggle) toggle.focus(); 
        } 
      }, { signal });

      window.matchMedia('(min-width: 781px)').addEventListener('change', closeMenu, { signal });
    }

    disconnectedCallback() { 
      if (this.controller) {
        this.controller.abort(); 
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsw-home-planner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bsw-home-planner')) {
  customElements.define('bsw-home-planner', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;

      const form = this.querySelector('[data-bsw-calc-form]');
      if (!form) return;

      const widthInput = this.querySelector('[data-bsw-wall-width]');
      const heightInput = this.querySelector('[data-bsw-wall-height]');
      const allowanceInput = this.querySelector('[data-bsw-allowance]');
      const errorElem = this.querySelector('[data-bsw-calc-error]');
      const outputArea = this.querySelector('[data-bsw-area-output]');
      const outputBase = this.querySelector('[data-bsw-base-output]');
      const outputTotal = this.querySelector('[data-bsw-total-output]');

      let calcQueued = false;

      const calculate = () => {
        calcQueued = false;
        const width = widthInput.valueAsNumber;
        const height = heightInput.valueAsNumber;
        const wastePercent = Number(allowanceInput.value);

        const valid = Number.isFinite(width) && Number.isFinite(height) && width >= 0.01 && height >= 0.01 && width <= 1000 && height <= 1000 && [0, 5, 10, 15].includes(wastePercent);
        
        errorElem.textContent = valid ? '' : this.dataset.error;
        
        if (!valid) { 
          outputArea.textContent = '—';
          outputBase.textContent = '—';
          outputTotal.textContent = '—';
          return; 
        }

        const area = width * height;
        const unitsNeeded = Math.ceil(Number((area * 4.5).toFixed(8)));
        const extraUnits = Math.ceil(Number((area * 4.5 * (1 + wastePercent / 100)).toFixed(8)));  

        outputArea.textContent = area.toFixed(1).replace('.0', '');
        outputBase.textContent = unitsNeeded.toLocaleString();
        outputTotal.textContent = extraUnits.toLocaleString();
      };

      const requestCalculation = () => {
        if (!calcQueued) {
          calcQueued = true;
          window.requestAnimationFrame(calculate);
        }
      };

      form.addEventListener('input', requestCalculation, { signal, passive: true });
      form.addEventListener('change', requestCalculation, { signal, passive: true });
      form.addEventListener('submit', event => { 
        event.preventDefault(); 
        calculate(); 
      }, { signal });

      calculate();
    }

    disconnectedCallback() { 
      if (this.controller) {
        this.controller.abort(); 
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsw-tiles-planner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bsw-tiles-planner')) {
  customElements.define('bsw-tiles-planner', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      this.widthInput = this.querySelector('[data-width]');
      this.heightInput = this.querySelector('[data-height]');
      this.allowanceInput = this.querySelector('[data-allowance]');
      this.inputs = [this.widthInput, this.heightInput, this.allowanceInput];
      this.inquiry = this.querySelector('[data-inquiry]');
      this.fallbackUrl = this.inquiry.getAttribute('href');
      
      this.addEventListener('input', () => this.update(), {signal: this.controller.signal});
      this.inquiry.addEventListener('click', (event) => {
        if (this.inquiry.getAttribute('aria-disabled') === 'true') event.preventDefault();
      }, {signal: this.controller.signal});
      
      this.update();
    }
    disconnectedCallback() { 
      if (this.controller) this.controller.abort(); 
    }
    update() {
      const width = parseFloat(this.widthInput.value) || 0;
      const height = parseFloat(this.heightInput.value) || 0;
      const allowance = parseFloat(this.allowanceInput.value) || 0;

      const count = this.querySelector('[data-count]');
      const summary = this.querySelector('[data-summary]');

      const valid = width > 0 && height > 0 && width <= 1000 && height <= 1000 && allowance >= 0 && allowance <= 100;
      this.inputs.forEach(input => input.setAttribute('aria-invalid', String(!input.validity.valid)));

      if (!valid) {
        if (count) count.textContent = '—';
        if (summary) summary.textContent = 'Please enter valid dimensions.';
        this.inquiry.setAttribute('aria-disabled', 'true');
        this.inquiry.removeAttribute('href');
        return;
      }

      const area = Number((width * height).toFixed(1));
      const pieces = Math.ceil(Number((area * 4.5 * (1 + allowance / 100)).toFixed(8)));

      if (count) count.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en').format(pieces);
      if (summary) {
        summary.textContent = `${area} sq ft wall area · ${allowance}% allowance for cuts and spares.`;
      }

      this.inquiry.removeAttribute('aria-disabled');
      const phone = this.dataset.whatsapp ? this.dataset.whatsapp.replace(/[^0-9]/g, '') : '';
      const requestText = `Hello, I need an estimate for ${pieces} salt tiles (${width}ft x ${height}ft with ${allowance}% allowance).`;
      this.inquiry.href = phone ? `https://wa.me/${phone}?text=${encodeURIComponent(requestText)}` : this.fallbackUrl;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsw-white-guide"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bsw-white-guide-visibility')) {
  customElements.define('bsw-white-guide-visibility', class extends HTMLElement {
    connectedCallback() {
      const content = this.querySelector('.bsw-white-content');
      const fallback = this.querySelector('.bsw-white-return');
      this.syncVisibility = () => {
        const params = new URLSearchParams(window.location.search);
        const filtered = [...params].some(([key, value]) => key.startsWith('filter.') && value !== '');
        const hidden = !content || filtered || Number(params.get('page') || 1) > 1;
        if (content) content.hidden = hidden;
        fallback.hidden = !hidden;
      };
      this.observer = new MutationObserver(this.syncVisibility);
      const grid = document.getElementById('ProductGridContainer');
      if (grid) this.observer.observe(grid, { childList: true });
      window.addEventListener('popstate', this.syncVisibility);
      this.syncVisibility();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('popstate', this.syncVisibility);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsw-white-tiles-guide"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bsw-white-planner')) {
  customElements.define('bsw-white-planner', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      this.widthInput = this.querySelector('[data-width]');
      this.heightInput = this.querySelector('[data-height]');
      this.allowanceInput = this.querySelector('[data-allowance]');
      this.inputs = [this.widthInput, this.heightInput, this.allowanceInput];
      this.inquiry = this.querySelector('[data-inquiry]');
      this.fallbackUrl = this.inquiry.getAttribute('href');
      
      this.addEventListener('input', () => this.update(), {signal: this.controller.signal});
      this.inquiry.addEventListener('click', (event) => {
        if (this.inquiry.getAttribute('aria-disabled') === 'true') event.preventDefault();
      }, {signal: this.controller.signal});
      
      this.update();
    }
    disconnectedCallback() { 
      if (this.controller) this.controller.abort(); 
    }
    update() {
      const width = parseFloat(this.widthInput.value) || 0;
      const height = parseFloat(this.heightInput.value) || 0;
      const allowance = parseFloat(this.allowanceInput.value) || 0;

      const count = this.querySelector('[data-count]');
      const summary = this.querySelector('[data-summary]');

      const valid = width > 0 && height > 0 && width <= 1000 && height <= 1000 && allowance >= 0 && allowance <= 100;
      this.inputs.forEach(input => input.setAttribute('aria-invalid', String(!input.validity.valid)));

      if (!valid) {
        if (count) count.textContent = '—';
        if (summary) summary.textContent = 'Please enter valid dimensions.';
        this.inquiry.setAttribute('aria-disabled', 'true');
        this.inquiry.removeAttribute('href');
        return;
      }

      const area = Number((width * height).toFixed(1));
      const pieces = Math.ceil(Number((area * 4.5 * (1 + allowance / 100)).toFixed(8)));

      if (count) count.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en').format(pieces);
      if (summary) {
        summary.textContent = `${area} sq ft wall area · ${allowance}% allowance for cuts and spares.`;
      }

      this.inquiry.removeAttribute('aria-disabled');
      const phone = this.dataset.whatsapp ? this.dataset.whatsapp.replace(/[^0-9]/g, '') : '';
      const requestText = `Hello, I need an estimate for ${pieces} white salt tiles (${width}ft x ${height}ft with ${allowance}% allowance).`;
      this.inquiry.href = phone ? `https://wa.me/${phone}?text=${encodeURIComponent(requestText)}` : this.fallbackUrl;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-calc"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bsw-cost-estimator')) {
  customElements.define('bsw-cost-estimator', class extends HTMLElement {
    static estimate(width, height, allowance, tubes) {
      if (![width, height, allowance, tubes].every(Number.isFinite) || width < 0.01 || height < 0.01 || width > 1000 || height > 1000 || allowance < 0 || allowance > 100 || !Number.isInteger(tubes) || tubes < 0 || tubes > 10000) return null;
      const area = width * height;
      const base = Math.ceil(Number((area * 4.5).toFixed(8)));
      const pieces = Math.ceil(Number((area * 4.5 * (1 + allowance / 100)).toFixed(8)));
      return { area, base, pieces, tubes };
    }
    static costs(pieces, tubes, unitPrice, adhesivePrice) {
      const validPrice = price => Number.isInteger(price) && price >= 0;
      const saltCost = validPrice(unitPrice) ? pieces * unitPrice : null;
      const adhesiveCost = tubes === 0 ? 0 : validPrice(adhesivePrice) ? tubes * adhesivePrice : null;
      const total = saltCost !== null && adhesiveCost !== null ? saltCost + adhesiveCost : null;
      return { salt_cost: saltCost, adhesive_cost: adhesiveCost, total };
    }
    connectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const select = this.querySelector('[data-product]');
      const fields = ['width', 'height', 'waste', 'tubes'].map(key => this.querySelector(`[data-${key}]`));
      const form = this.querySelector('form');
      const submit = this.querySelector('[data-submit]');
      const body = this.querySelector('[data-quote-body]');
      const message = this.querySelector('[data-message]');
      const priceLabel = this.querySelector('[data-price-label]');
      const outputs = Object.fromEntries(Array.from(this.querySelectorAll('[data-output]'), node => [node.dataset.output, node]));
      const money = cents => {
        if (cents === null) return '—';
        try { return new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency }).format(cents / 100); }
        catch { return `${(cents / 100).toFixed(2)} ${this.dataset.currency}`; }
      };
      const number = value => new Intl.NumberFormat(this.dataset.locale || 'en', { maximumFractionDigits: 4 }).format(value);
      const priceFrom = data => data && data.available === 'true' && data.price !== '' && data.price !== undefined ? Number(data.price) : null;
      const calculate = () => {
        const option = select.selectedOptions[0];
        const unitPrice = priceFrom(option?.dataset);
        const adhesivePrice = priceFrom({ price: this.dataset.adhesivePrice, available: this.dataset.adhesiveAvailable });
        
        // Dynamic label based on selection (Tile vs Brick)
        const itemType = option?.dataset.type || 'Tile';
        if (priceLabel) {
          priceLabel.textContent = `Each ${itemType} Price`;
        }

        outputs.unit_price.textContent = money(unitPrice);
        const estimate = this.constructor.estimate(...fields.map(field => field.valueAsNumber));
        const valid = Boolean(estimate && option && fields.every(field => field.validity.valid));
        if (submit) submit.disabled = !valid;
        if (!valid) {
          Object.entries(outputs).forEach(([key, node]) => { if (key !== 'unit_price') node.textContent = '—'; });
          message.textContent = option ? this.dataset.invalid : this.dataset.unavailable;
          if (body) body.value = '';
          return false;
        }
        const costs = this.constructor.costs(estimate.pieces, estimate.tubes, unitPrice, adhesivePrice);
        for (const [key, value] of Object.entries(estimate)) outputs[key].textContent = number(value);
        for (const [key, value] of Object.entries(costs)) outputs[key].textContent = money(value);
        message.textContent = costs.total === null ? this.dataset.unavailable : '';
        if (body) {
          const details = [this.dataset.quoteTitle, option.textContent, `Variant: ${option.value}`];
          for (const field of fields) details.push(`${this.querySelector(`label[for="${field.id}"]`).textContent}: ${field.value}`);
          for (const label of this.querySelectorAll('[data-result-label]')) details.push(`${label.textContent}: ${outputs[label.dataset.resultLabel].textContent}`);
          details.push(this.querySelector('[data-exclusions]').textContent);
          body.value = details.join('\n');
        }
        return true;
      };
      for (const event of ['input', 'change']) this.addEventListener(event, calculate, { signal });
      if (form) form.addEventListener('submit', event => {
        if (!calculate()) {
          event.preventDefault();
          const invalid = fields.find(field => !field.validity.valid);
          if (invalid) { invalid.focus(); invalid.reportValidity(); }
        }
      }, { signal });
      calculate();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
